enum MotivationSchemeEnum {
  /**
   * Удержание, привлечение, брокерка
   */
  DEFAULT = "DEFAULT",

  /**
   * Вознаграждение за привлеченного пользователя
   */
  REFERRAL = "REFERRAL",
}

export default MotivationSchemeEnum;
